/** Renderar en illustration (SVG) som en centrerad figur med bildtext.
 *  Används både som `img`-override i react-markdown (kapiteltext, bildspel) och
 *  direkt för avsnittsknutna figurer. `bildtext` är den synliga bildtexten;
 *  `alt` är beskrivningen för skärmläsare (faller tillbaka på bildtexten). */
export default function Illustration({ src, alt, bildtext }: { src?: string; alt?: string; bildtext?: string }) {
  if (!src) return null
  const synligText = bildtext ?? alt
  return (
    <span className="illustration">
      <img src={src} alt={alt ?? bildtext ?? ''} loading="lazy" />
      {synligText && <span className="illustration-bildtext">{synligText}</span>}
    </span>
  )
}
